// extracted by mini-css-extract-plugin
export default {"wrapper":"Signup_wrapper__yxAqK","left":"Signup_left__J2z30","right":"Signup_right__dQ6m9","head":"Signup_head__F8D9J","btn":"Signup_btn__cF8rf","signup":"Signup_signup__fWnTx"};